import { render } from "./NewButton.vue?vue&type=template&id=0d7d5104&scoped=true"
import script from "./NewButton.vue?vue&type=script&lang=js"
export * from "./NewButton.vue?vue&type=script&lang=js"

import "./NewButton.vue?vue&type=style&index=0&id=0d7d5104&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7d5104"]])

export default __exports__